<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" class="pull-right" @click="$router.push('/admin/klanten/toevoegen')">
              Klant toevoegen
            </b-button>
          </b-col>
        </b-row>
        <resource-index header="Klanten" endpoint="customers" show-route="customers.view" add-route="customers.create"></resource-index>
      </div>
    </div>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
  name: 'customers',
  components: { ResourceIndex },
}

</script>
